module.exports = __webpack_public_path__ + "static/media/conteiner.49e4a860.png";